import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import PlayIcon from './icons/PlayIcon';
import ModalBlock from '../ModalBlock/ModalBlock';
import VideoItem from '../VideoItem/VideoItem';
import styles from './styles';
import { sendYandexMetrikaEvent } from '../../helpers/yandexMetrika';
import { sendMyTargetEvent } from '../../helpers/myTarget';

function VideoBlock({
  children,
  description,
  customStyles,
  video,
  style = 'default',
  card = false,
  ratio,
  ymEvent,
  myTargetEvent,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const startVideo = () => {
    if (video) {
      setModalOpen(true);
      if (ymEvent) {
        sendYandexMetrikaEvent(ymEvent);
      }
      if (myTargetEvent) {
        sendMyTargetEvent(myTargetEvent);
      }
    }
  };
  return (
    <Box className={card && 'card'} sx={customStyles}>
      <Box
        onClick={startVideo}
        sx={styles.previewWrapper(video)}
        className="previewWrapper"
      >
        <Box sx={styles.preview} className="preview">
          {children || <StaticImage src="./images/preview.png" alt="preview" />}

          {video && (
            <Button sx={styles.videoButton}>
              <Box sx={styles.iconWrapper}>
                <PlayIcon />
              </Box>
            </Button>
          )}
        </Box>
      </Box>
      {description && (
        <Typography variant="desktopP1" sx={styles[style]}>
          {description}
        </Typography>
      )}

      {typeof window !== 'undefined' && (
        <ModalBlock
          isFreeForm
          isOpen={modalOpen}
          handleClose={() => {
            setModalOpen(false);
          }}
        >
          <Box sx={styles.video(ratio)}>
            <VideoItem video={video} />
          </Box>
        </ModalBlock>
      )}
    </Box>
  );
}

export default VideoBlock;
